import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Typography,
} from '@mui/material'

import { FAQCategories, FAQCategoryDetails } from '../constants/FAQ'
import { styles } from './SupportAccordion.styles'
import SupportSubAccordion from './SupportSubAccordion'

export interface SupportAccordionProps {
	activeFAQDropdown: number
	category: FAQCategories
	dropdownId: number
	setActiveFAQDropdown: (id: number) => void
}

export const SupportAccordion = ({
	activeFAQDropdown,
	category,
	dropdownId,
	setActiveFAQDropdown,
}: SupportAccordionProps) => {
	const handleClick = () => {
		if (activeFAQDropdown === dropdownId) {
			setActiveFAQDropdown(-1)
		} else {
			setActiveFAQDropdown(dropdownId)
		}
	}

	return (
		<Box>
			<Accordion
				elevation={0}
				sx={styles.accordion}
				expanded={activeFAQDropdown === dropdownId}
			>
				<AccordionSummary
					sx={styles.accordionSummary}
					expandIcon={<ExpandMoreIcon sx={styles.expandIcon} />}
					onClick={handleClick}
				>
					<Typography sx={styles.categoryTypography}>
						{category}
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<SupportSubAccordion
						categoryDetails={FAQCategoryDetails[category]}
						parentOpen={activeFAQDropdown === dropdownId}
					/>
				</AccordionDetails>
			</Accordion>
		</Box>
	)
}

export default SupportAccordion
